import React from "react"

import moment from 'moment'

import { withRouter } from "react-router-dom";

import BaseTable from "./BaseTable"

import SubmissionActionsCell from "./cells/SubmissionActionsCell"

import AuthManager from '../../../utils/AuthManager'
import General from '../../../utils/General'

import SubmissionModal from "../modal/SubmissionModal";

const STATUSES = [
  {
    label: "All",
    value: "all"
  },
  {
    label: "New",
    value: "new"
  },
  {
    label: "Open",
    value: "open"
  },
  {
    label: "Closed",
    value: "closed"
  }
]

class SubmissionsTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      websiteId: AuthManager.currentWebsite.id,
      statuses: STATUSES
    }

    this.table = React.createRef()
  }

  _getColumns() {
    let {
    } = this.state

    return [
      {
        Header: 'Date',
        id: 'created_at',
        accessor: submission => moment(submission.created_at).format('DD/MM/YYYY'),
        type: "date",
        format: "%d %b %Y"
      },
      {
        Header: 'Status',
        id: "status.name",
        accessor: submission => General.toTitleCase(submission.status.name),
        exportable: false
      },
      {
        Header: 'Name',
        id: "data.first_name",
        accessor: submission => submission.data.contact_first_name + " " + submission.data.contact_last_name,
        exportable: false
      },
      {
        Header: 'Email',
        accessor: "data.contact_email",
        exportable: false
      },
      {
        Header: 'Phone',
        accessor: "data.contact_phone",
        exportable: false
      },
      {
        Header: 'Actions',
        id: 'actions',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          let submission = rowInfo.original
          return (
            <SubmissionActionsCell
              submission={submission}
              onEditPressed={submission => this.setState({ selectedSubmission: submission, showSubmissionEditModal: true })}
            />
          )
        }
      }
    ]
  }

  render() {
    let {
      websiteId,
      selectedSubmission,
      showSubmissionEditModal: showSubmissionEditModal,
    } = this.state

    const columns = this._getColumns()

    return (
      <>
        <BaseTable
          ref={this.table}
          endpoint={window.Api.Submissions+"?website_id="+websiteId}
          title="Leads"
          columns={columns}
          searchFilterName="status"
          params={{
            website_id: websiteId
          }}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              style: {
                paddingLeft: 10,
                overflow: column.Header === "Actions" ? 'visible' : 'hidden'
              }
            }
          }}
        />
        {
          showSubmissionEditModal &&
          <SubmissionModal
            show={showSubmissionEditModal}
            submissionId={selectedSubmission.id}
            onUpdated={() => this.setState({selectedSubmission: null, showSubmissionEditModal: false})}
            onHide={() => this.setState({selectedSubmission: null, showSubmissionEditModal: false})}
          />
        }
      </>
    )
  }
}

export default withRouter(SubmissionsTable);
